import React from 'react';

import { GridItem } from '../GridItem';
import { Heading } from '../Heading';
import { PageGrid } from '../PageGrid';
import { Stack } from '../Stack';
import { ImageGallery as ImageGalleryComponent } from './_Gallery';

type GalleryProps = {
  id: string;
  image?: React.ReactElement;
  title: React.ReactElement;
  description: React.ReactElement;
};

type ImageGalleryProps = {
  title?: React.ReactElement;
  text?: React.ReactElement;
  gallery?: GalleryProps[];
  isContained?: boolean;
};

export const ImageGallery = ({ title, text, gallery, isContained }: ImageGalleryProps) => {
  if (isContained) {
    return <ImageGalleryContent title={title} text={text} gallery={gallery} isContained />;
  }

  return (
    <PageGrid>
      <GridItem
        columnStart={isContained ? '1' : { initial: '1', md: '3' }}
        columnEnd={isContained ? '-1' : { initial: '-1', md: '-3' }}
      >
        <ImageGalleryContent title={title} text={text} gallery={gallery} isContained />
      </GridItem>
    </PageGrid>
  );
};

const ImageGalleryContent = ({ title, text, gallery }: ImageGalleryProps) => {
  return (
    <Stack gap={{ initial: 6, md: 10 }}>
      <Stack gap={6}>
        <Heading size="h2" isResponsive>
          {title}
        </Heading>
        {text}
      </Stack>
      {gallery ? <ImageGalleryComponent gallery={gallery} /> : null}
    </Stack>
  );
};

